var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image_icon_",
    "data-name": "image  icon ",
    transform: "translate(-1156.375 -530.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18880",
    "data-name": "Rectangle 18880",
    width: 128,
    height: 128,
    transform: "translate(1156.375 530.375)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(1173.31 547.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18879",
    "data-name": "Rectangle 18879",
    width: 94,
    height: 94,
    rx: 2,
    transform: "translate(0.064 0.063)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2443",
    "data-name": "Ellipse 2443",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(21.064 21.063)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59134",
    "data-name": "Path 59134",
    d: "M88.051,35.954,62.1,10,5,67.1",
    transform: "translate(5.811 26.966)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.eebbd2fcb5848298b6e47bbef288259e.svg";
export { ForwardRef as ReactComponent };